import { http } from '@/helpers/http'
import { isCloudFileShareUrl, resolveImportUrl } from '@/helpers/url'
import { ERemoteImportURLType } from '@/types/remote-imports'
import type { TDetectImportUrlTypeResponse, TImportUrlCheckLoader, TImportUrlInfo } from '@/types/remote-imports'

const knownTypes: string[] = Object.values(ERemoteImportURLType)

function isKnownType(type: string): type is ERemoteImportURLType {
  return knownTypes.includes(type)
}

async function detectOnServer(url: string): Promise<Omit<TImportUrlInfo, 'url'> | null> {
  try {
    const res = await http.post<TDetectImportUrlTypeResponse>('/detect_import_url_type', { url })
    if (res?.status !== 'success' || !isKnownType(res.type)) {
      return null
    }

    return {
      type: res.type,
      ...(res.fileName ? { fileName: res.fileName } : {}),
      ...(res.sizeBytes ? { sizeBytes: res.sizeBytes } : {}),
    }
  } catch {
    return null
  }
}

export async function resolveImportUrlInfo(
  input: string,
  currentType?: ERemoteImportURLType,
  loader?: TImportUrlCheckLoader,
): Promise<TImportUrlInfo | null> {
  const resolved = resolveImportUrl(input)
  if (!resolved) {
    return null
  }
  if (resolved.type !== ERemoteImportURLType.Web || !isCloudFileShareUrl(resolved.url)) {
    return resolved
  }

  loader?.show('Checking the link...')
  const detected = await detectOnServer(resolved.url)
  loader?.hide()

  return { url: resolved.url, ...(detected ?? { type: currentType ?? ERemoteImportURLType.Web }) }
}
